/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The colors for loader components
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import { FreshAsphalt } from './palette';

// Circle
export const loaderCircleColor = FreshAsphalt;

// Linear
export const loaderLinearBgColor = `linear-gradient(
    to right,
    rgba(216, 216, 216, 0.5) 8%,
    rgba(238, 238, 238, 0.5) 33%,
    rgba(216, 216, 216, 0.5) 60%)`;

